import { _ as _toConsumableArray } from '../toConsumableArray-5dfc8238.js';
import { _ as _defineProperty } from '../defineProperty-2d1aa32d.js';
import { authorizationHeader } from '@picsart/growth-rc/services/auth';
import { getAnalyticsInfo } from '../analyticsService/index.js';
import { get, getApiUrl, patch, post } from '../httpService/index.js';
import { MAXIMIZER_TIERS, TIERS } from '../constants/index.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var fetchSubscriptionPlans = function fetchSubscriptionPlans() {
  var scopes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['gold'];
  var scopesArray = Array.isArray(scopes) ? scopes : [scopes];
  return get("".concat(getApiUrl(), "/shop/subscription/plans?scope_id=").concat(scopesArray.toString()));
};
var cancelSubscription = function cancelSubscription(original_order_id, accessToken) {
  return patch("".concat(getApiUrl(), "/shop/subscription/v2/cancel"), {
    original_order_id: original_order_id
  }, {
    headers: authorizationHeader(accessToken)
  });
};
var restoreSubscription = function restoreSubscription(original_order_id, accessToken) {
  return patch("".concat(getApiUrl(), "/shop/subscription/v2/restore"), {
    original_order_id: original_order_id
  }, {
    headers: authorizationHeader(accessToken)
  });
};
var switchSubscription = function switchSubscription(data, accessToken) {
  var payload = _objectSpread(_objectSpread({}, data), {}, {
    analytics_info: getAnalyticsInfo()
  });
  return patch("".concat(getApiUrl(), "/shop/subscription/adyen/plan/switch"), payload, {
    headers: authorizationHeader(accessToken)
  });
};
var restartSubscription = function restartSubscription(data, accessToken) {
  var payload = _objectSpread(_objectSpread({}, data), {}, {
    analyticsInfo: getAnalyticsInfo()
  });
  return patch("".concat(getApiUrl(), "/shop/subscription/adyen/restart"), payload, {
    headers: authorizationHeader(accessToken)
  });
};
var calculateDiscount = function calculateDiscount(subscriptionPlans, isMaxMode) {
  var _yearlyPlan$price, _yearlyPlan$price2, _monthlyPlan$price, _monthlyPlan$price2;
  // in some cases isMaxMode can be mandatory
  var isMaximizerMode = isMaxMode !== null && isMaxMode !== void 0 ? isMaxMode : subscriptionPlans.some(function (plan) {
    return MAXIMIZER_TIERS.includes(plan.tier_id);
  });
  var plans = subscriptionPlans.filter(function (plan) {
    return isMaximizerMode ? MAXIMIZER_TIERS.includes(plan.tier_id) : _toConsumableArray(TIERS).includes(plan.tier_id);
  });
  if (plans.length !== 2) {
    return undefined;
  }
  var yearlyPlan = plans.find(function (plan) {
    return plan.frequency === 'yearly';
  });
  var monthlyPlan = plans.find(function (plan) {
    return plan.frequency === 'monthly';
  });
  var yearlyPlanPrice = (yearlyPlan === null || yearlyPlan === void 0 || (_yearlyPlan$price = yearlyPlan.price) === null || _yearlyPlan$price === void 0 ? void 0 : _yearlyPlan$price.initial_value) || (yearlyPlan === null || yearlyPlan === void 0 || (_yearlyPlan$price2 = yearlyPlan.price) === null || _yearlyPlan$price2 === void 0 ? void 0 : _yearlyPlan$price2.value);
  var monthlyPlanPrice = (monthlyPlan === null || monthlyPlan === void 0 || (_monthlyPlan$price = monthlyPlan.price) === null || _monthlyPlan$price === void 0 ? void 0 : _monthlyPlan$price.initial_value) || (monthlyPlan === null || monthlyPlan === void 0 || (_monthlyPlan$price2 = monthlyPlan.price) === null || _monthlyPlan$price2 === void 0 ? void 0 : _monthlyPlan$price2.value);
  if (!yearlyPlanPrice || !monthlyPlanPrice) {
    return undefined;
  }
  return Math.abs(Math.round((yearlyPlanPrice / 12 - monthlyPlanPrice) / monthlyPlanPrice * 100));
};
var fetchSwitchingPlanPrice = function fetchSwitchingPlanPrice(accessToken, data) {
  return post("".concat(getApiUrl(), "/shop/subscription/adyen/plans/switchable/price"), data, {
    headers: _objectSpread({}, authorizationHeader(accessToken))
  });
};
var getPlanByTier = function getPlanByTier(tier) {
  return get("".concat(getApiUrl(), "/shop/subscription/plan/").concat(tier));
};
var subscriptionsService = {
  fetchSwitchingPlanPrice: fetchSwitchingPlanPrice,
  fetchSubscriptionPlans: fetchSubscriptionPlans,
  restoreSubscription: restoreSubscription,
  cancelSubscription: cancelSubscription,
  switchSubscription: switchSubscription,
  calculateDiscount: calculateDiscount
};

export { calculateDiscount, cancelSubscription, subscriptionsService as default, fetchSubscriptionPlans, fetchSwitchingPlanPrice, getPlanByTier, restartSubscription, restoreSubscription, switchSubscription };
//# sourceMappingURL=index.js.map
